'use strict';

var _ = require('lodash');
var CompetitiveViewChartDataService = function CompetitiveViewChartDataService(fareChartTransformationService, FaresOptimizerConstants) {
  var transformedChartData = {
    fareLadderData: undefined,
    settings: undefined,
    showAdjustDatesAndFares: false,
    isRecommendedFareChart: false,
    webFareChartData: undefined,
    isWebFareChart: false
  };
  function effectiveFaresAvailable(recommendationEntry) {
    return !_.find(recommendationEntry.groupedRows, function (recommendation) {
      return !recommendation.isLinkedFbc && !recommendation.isDualRbdFare && _.isNil(recommendation.effectiveTotalFare);
    });
  }
  function checkForNewNonCancelledLadder(recommendationEntry) {
    return recommendationEntry.status === FaresOptimizerConstants.NEW && _.find(recommendationEntry.groupedRows, function (recommendation) {
      return recommendation.actionCode !== 'X';
    });
  }
  function recommendationsAvailable(recommendationEntry) {
    return !_.find(recommendationEntry.groupedRows, function (recommendation) {
      return _.isNil(recommendation.recommendedFareTotal);
    });
  }
  function isEffectiveFareChart(chartData) {
    return chartData.title.indexOf(FaresOptimizerConstants.EFFECTIVE_FARES_CHART_TITLE) > -1;
  }
  function isRecommendedFareChart(chartData) {
    return chartData.title.indexOf(FaresOptimizerConstants.RECOMMENDATION_CHART_TITLE) > -1;
  }
  function isCurrentFareChart(chartData) {
    return chartData.title.indexOf(FaresOptimizerConstants.CURRENT_FARE_CHART_TITLE) > -1;
  }
  function isWebFareChart(chartData) {
    return chartData.title.indexOf(FaresOptimizerConstants.WEB_FARE_CHART_TITLE) > -1;
  }
  function isCompetitorFareChart(chartData) {
    return !_.isEmpty(chartData.data.competitorFareLadder);
  }
  function initialize() {
    transformedChartData = {
      fareLadderData: undefined,
      settings: undefined,
      showAdjustDatesAndFares: false,
      isRecommendedFareChart: false,
      webFareChartData: undefined,
      isWebFareChart: false
    };
  }
  function copyCurrentFaresToEffectiveAndRecommendedFares(recommendationEntry) {
    _.map(recommendationEntry.groupedRows, function (recommendation) {
      if (recommendation.actionCode === 'X') {
        if (_.isNil(recommendation.recommendedFareBase)) {
          recommendation.recommendedFareBase = recommendation.currentFareBase;
        }
        if (_.isNil(recommendation.recommendedFareTotal)) {
          recommendation.recommendedFareTotal = recommendation.currentFareTotal;
        }
        if (_.isNil(recommendation.effectiveBaseFare)) {
          recommendation.effectiveBaseFare = recommendation.currentFareBase;
        }
        if (_.isNil(recommendation.effectiveTotalFare)) {
          recommendation.effectiveTotalFare = recommendation.currentFareTotal;
        }
      }
    });
  }
  function getChartDataForCompetitiveView(chartData, settings) {
    initialize();
    var recommendationEntry = chartData.data;
    copyCurrentFaresToEffectiveAndRecommendedFares(recommendationEntry);
    if (isEffectiveFareChart(chartData)) {
      settings.type = 'effective';
      if (checkForNewNonCancelledLadder(recommendationEntry)) {
        transformedChartData.showAdjustDatesAndFares = true;
      }
      if (effectiveFaresAvailable(recommendationEntry)) {
        transformedChartData.fareLadderData = fareChartTransformationService.transformHostFareLadder(recommendationEntry, settings);
      }
      transformedChartData.settings = settings;
      return transformedChartData;
    }
    if (isCurrentFareChart(chartData)) {
      settings.type = 'current';
      transformedChartData.fareLadderData = fareChartTransformationService.transformCurrentHostFareLadder(recommendationEntry, settings);
      transformedChartData.settings = settings;
      return transformedChartData;
    }
    if (isRecommendedFareChart(chartData) && recommendationsAvailable(recommendationEntry)) {
      settings.type = 'recommendation';
      transformedChartData.fareLadderData = fareChartTransformationService.transformHostFareLadder(recommendationEntry, settings);
      transformedChartData.isRecommendedFareChart = true;
      transformedChartData.settings = settings;
      return transformedChartData;
    }
    if (isCompetitorFareChart(chartData)) {
      settings.type = 'competitor';
      transformedChartData.fareLadderData = fareChartTransformationService.transformCompetitorFareLadder(recommendationEntry.competitorFareLadder, settings);
      transformedChartData.settings = settings;
      return transformedChartData;
    }
    if (isWebFareChart(chartData)) {
      settings.type = 'webfare';
      transformedChartData.webFareChartData = fareChartTransformationService.transformWebFareData(recommendationEntry, settings);
      transformedChartData.isWebFareChart = true;
      transformedChartData.settings = settings;
      return transformedChartData;
    }
  }
  return {
    getChartDataForCompetitiveView: getChartDataForCompetitiveView
  };
};
CompetitiveViewChartDataService.$inject = ['FareChartTransformationService', 'FaresOptimizerConstants'];
module.exports = CompetitiveViewChartDataService;